// 대운이 바뀔 때 화면에 보일 짧은 장면 문장. 기록과 승인된 문장 표에서만 만든다.
// 문장 표는 luckScenes.js(사용자 승인, 고서 원문 확인 전)이다. 표가 없으면(null) 화면과 기록에 아무것도 나오지 않는다.
// 전환기(대운이 시작한 해부터 3년), 15세 이상, 새 규칙(luckModel)의 진행, 전환 유형이 있는 격국에만 나온다.
import { luckAt } from './luckPhase.js';
import { transitionDetail } from './luckTransition.js';
import { essenceFor } from './events.js';
import { GROUP_LABEL } from './rules.js';
import { LUCK_SCENES } from './luckScenes.js';

let TABLE = LUCK_SCENES;
export const getLuckScenes = () => TABLE;
// 테스트용: 표를 바꾸거나(null 이면 표 없음) 승인된 표로 되돌린다.
export const setLuckScenes = (table) => { TABLE = table; };
export const resetLuckScenes = () => { TABLE = LUCK_SCENES; };

/** { text(나이 포함), body(나이 제외), type, group, ten, yearsSince, startAge, cardIds } | null */
export function luckScene(run, table = TABLE) {
  if (!table || run?.luckModel !== 'environment' || !(run.age >= 15)) return null;
  const luck = luckAt(run.saju, run.age);
  if (!luck.inTransition) return null;
  const detail = transitionDetail(essenceFor(run.saju), luck);
  if (!detail) return null;
  // 격국×십성 예외로 유형이 달라진 칸은 관계 문장이 맞지 않으므로 유형별 일반 문장을 쓴다.
  const sentence = (!detail.overridden && table.relations?.[detail.yong]?.[detail.relation]) || table.byType?.[detail.type];
  if (!sentence) return null;
  const body = `${GROUP_LABEL[luck.group]} 쪽 새 대운이 들어와요. ${sentence}`;   // 나이를 뺀 문장(진행 기록 목록은 나이를 따로 붙인다)
  return { text: `${run.age}세 · ${body}`, body, type: detail.type, group: luck.group, ten: luck.ten,
    yearsSince: luck.yearsSince, startAge: luck.startAge, cardIds: [...(table.cardIds ?? [])] };
}
